import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { Capacitor } from "@capacitor/core";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isNative = Capacitor.isNativePlatform();
  const isMobile = isNative || window.innerWidth < 768;
  const position = isMobile ? "top-center" : "bottom-center";

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position={position}
      toastOptions={{
        duration: 3000,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-native-elevated group-[.toaster]:rounded-native",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-native-caption",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-lg",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-lg",
          error: "group-[.toaster]:border-destructive/30 group-[.toaster]:bg-destructive/5",
          success: "group-[.toaster]:border-success/30 group-[.toaster]:bg-success/5",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
